import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { getLength as n, getMidpoint as t } from "./coordsUtils.js";

function l(n) {
  return n ? n.hasZ ? [n.xmax - n.xmin / 2, n.ymax - n.ymin / 2, n.zmax - n.zmin / 2] : [n.xmax - n.xmin / 2, n.ymax - n.ymin / 2] : null;
}

function e(n) {
  return n ? o(n.rings, n.hasZ) : null;
}

function o(n, t) {
  if (!n || !n.length) return null;
  var l = [],
      e = [],
      o = t ? [1 / 0, -1 / 0, 1 / 0, -1 / 0, 1 / 0, -1 / 0] : [1 / 0, -1 / 0, 1 / 0, -1 / 0];

  for (var _h = 0, i = n.length; _h < i; _h++) {
    var _l = r(n[_h], t, o);

    _l && e.push(_l);
  }

  if (e.sort(function (n, l) {
    var e = n[2] - l[2];
    return 0 === e && t && (e = n[4] - l[4]), e;
  }), e.length && (l[0] = e[0][0], l[1] = e[0][1], t && (l[2] = e[0][3]), (l[0] < o[0] || l[0] > o[1] || l[1] < o[2] || l[1] > o[3] || t && (l[2] < o[4] || l[2] > o[5])) && (l.length = 0)), !l.length) {
    var _e = n[0] && n[0].length ? h(n[0], t) : null;

    if (!_e) return null;
    l[0] = _e[0], l[1] = _e[1], t && _e.length > 2 && (l[2] = _e[2]);
  }

  return l;
}

function r(n, t, l) {
  var e = 0,
      o = 0,
      r = 0,
      h = 0,
      i = 0;
  var u = n.length ? n[0][0] : 0,
      g = n.length ? n[0][1] : 0,
      s = n.length && t ? n[0][2] : 0;

  for (var f = 0; f < n.length; f++) {
    var _c = n[f],
        m = n[(f + 1) % n.length],
        _c2 = _slicedToArray(_c, 3),
        x = _c2[0],
        a = _c2[1],
        y = _c2[2],
        d = x - u,
        p = a - g,
        v = t ? y - s : void 0,
        _m = _slicedToArray(m, 3),
        z = _m[0],
        Z = _m[1],
        j = _m[2],
        U = z - u,
        b = Z - g,
        k = t ? j - s : void 0,
        q = d * b - U * p;

    if (h += q, e += (d + U) * q, o += (p + b) * q, t && _c.length > 2 && m.length > 2) {
      var _n = d * k - U * v;

      r += (v + k) * _n, i += _n;
    }

    x < l[0] && (l[0] = x), x > l[1] && (l[1] = x), a < l[2] && (l[2] = a), a > l[3] && (l[3] = a), t && (y < l[4] && (l[4] = y), y > l[5] && (l[5] = y));
  }

  if (h > 0 && (h *= -1), i > 0 && (i *= -1), !h) return null;
  h *= .5, i *= .5;
  var c = [e / (6 * h) + u, o / (6 * h) + g, h];
  return t && (l[4] === l[5] || 0 === i ? (c[3] = (l[4] + l[5]) / 2, c[4] = 0) : (c[3] = r / (6 * i) + s, c[4] = i)), c;
}

function h(l, e) {
  var o = e ? [0, 0, 0] : [0, 0],
      r = e ? [0, 0, 0] : [0, 0];
  var h = 0,
      i = 0,
      u = 0,
      g = 0;

  for (var s = 0, c = l.length; s < c - 1; s++) {
    var _c3 = l[s],
        f = l[s + 1];

    if (_c3 && f) {
      o[0] = _c3[0], o[1] = _c3[1], r[0] = f[0], r[1] = f[1], e && _c3.length > 2 && f.length > 2 && (o[2] = _c3[2], r[2] = f[2]);

      var _l2 = n(o, r);

      if (_l2) {
        h += _l2;

        var _n2 = t(_c3, f);

        i += _l2 * _n2[0], u += _l2 * _n2[1], e && _n2.length > 2 && (g += _l2 * _n2[2]);
      }
    }
  }

  return h > 0 ? e ? [i / h, u / h, g / h] : [i / h, u / h] : l.length ? l[0] : null;
}

export { l as extentCentroid, h as lineCentroid, e as polygonCentroid, o as ringsCentroid };